module.exports = __webpack_public_path__ + "static/cloud_giant-4e6dad86e7bc53ea2abce6ca97fe7339.jpg";